import { render, staticRenderFns } from "./service_card_record.vue?vue&type=template&id=5fd8479e"
import script from "./service_card_record.vue?vue&type=script&lang=js"
export * from "./service_card_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports